/**
 * 羽沢横浜国大→武蔵小杉は全て普通として扱う
 */
export const processTrains = (trains) => {
  return trains.map(train => {
    if (train.next_station_id === 11464 && train.direction === 'up' && train.line_id === 4 && train.train_kind_id !== 4) {
      return {...train, train_kind_id: 4}
    } else {
      return train
    }
  })
}
